import { Sorts } from "@domains/aggregates/interfaces/Reports/iReportsCommon";
import { ESortOrder } from "@domains/utils/sort";
import * as moment from "moment";
export var NRTabsEnum;
(function (NRTabsEnum) {
    NRTabsEnum["PRODUCT"] = "product";
    NRTabsEnum["EMPLOYEE"] = "employee";
    NRTabsEnum["LOCATION"] = "location";
})(NRTabsEnum || (NRTabsEnum = {}));
export var TabsArray = [
    {
        title: "Product - Revenue",
        eventKey: NRTabsEnum.PRODUCT,
    },
    {
        title: "Employee - Revenue",
        eventKey: NRTabsEnum.EMPLOYEE,
    },
    {
        title: "Location - Revenue",
        eventKey: NRTabsEnum.LOCATION,
    },
];
export var employeeHeadingTitles = [
    {
        title: "Employee Name",
        key: "empName",
    },
    {
        title: "Gross Revenue",
        key: "gross",
    },
    {
        title: "SB Passout ",
        key: "passout",
    },
    {
        title: "Refund/Reversal",
        key: "Refund",
    },
    {
        title: "Finance Cost",
        key: "Finance",
    },
    {
        title: "Net Reveneue",
        key: "NetReveneue",
    },
];
export var locationHeadingTitles = [
    {
        title: "Zone",
        key: "empName",
    },
    {
        title: "Gross Revenue",
        key: "gross",
    },
    {
        title: "SB Passout ",
        key: "passout",
    },
    {
        title: "Refund/Reversal",
        key: "Refund",
    },
    {
        title: "Finance Cost",
        key: "Finance",
    },
    {
        title: "Net Reveneue",
        key: "NetReveneue",
    },
];
export var headerQuaterList = [
    { title: "Select Quarter", value: "" },
    { title: "Quarter 1", value: "Q1" },
    { title: "Quarter 2", value: "Q2" },
    { title: "Quarter 3", value: "Q3" },
    { title: "Quarter 4", value: "Q4" },
];
export var headerNRList = { title: "LOB-NR", value: "LOB" };
export var headerRMList = { title: "RM-NR", value: "RM" };
export var headerQuarterListEnum;
(function (headerQuarterListEnum) {
    headerQuarterListEnum["QUARTER"] = "Quarter";
    headerQuarterListEnum["MONTHS"] = "Months";
})(headerQuarterListEnum || (headerQuarterListEnum = {}));
export var completeMonthList = [
    { title: "Select Month", value: "" },
    { title: "January", value: "Jan" },
    { title: "February", value: "Feb" },
    { title: "March", value: "Mar" },
    { title: "April", value: "Apr" },
    { title: "May", value: "May" },
    { title: "June", value: "Jun" },
    { title: "July", value: "Jul" },
    { title: "August", value: "Aug" },
    { title: "September", value: "Sep" },
    { title: "October", value: "Oct" },
    { title: "November", value: "Nov" },
    { title: "December", value: "Dec" },
];
export var headerPeriodList = [
    { title: "Select Period", value: "" },
    { title: "Quarter", value: headerQuarterListEnum.QUARTER },
    { title: "Month", value: headerQuarterListEnum.MONTHS },
];
export var headerMonthsList = [
    [
        { title: "Select Month", value: "" },
        { title: "April", value: "Apr" },
        { title: "May", value: "May" },
        { title: "June", value: "Jun" },
    ],
    [
        { title: "Select Month", value: "" },
        { title: "July", value: "Jul" },
        { title: "August", value: "Aug" },
        { title: "September", value: "Sep" },
    ],
    [
        { title: "Select Month", value: "" },
        { title: "October", value: "Oct" },
        { title: "November", value: "Nov" },
        { title: "December", value: "Dec" },
    ],
    [
        { title: "Select Month", value: "" },
        { title: "January", value: "Jan" },
        { title: "February", value: "Feb" },
        { title: "March", value: "Mar" },
    ],
];
export var getQuater = function () {
    var q = [3, 0, 1, 2];
    return q[Math.floor(new Date().getMonth() / 3)];
};
export var LocationDataKeyEnum;
(function (LocationDataKeyEnum) {
    LocationDataKeyEnum["REGION_ID"] = "regionid";
    LocationDataKeyEnum["ZONE_ID"] = "zoneid";
})(LocationDataKeyEnum || (LocationDataKeyEnum = {}));
export var constantPageSize = "500";
// export const tableHeadingExecution = (
//   year: string,
//   quarter: string,
//   month: string
// ) => {
//   let result = "";
//   if (year && !quarter && !month) {
//     result = year;
//   } else if (year && quarter && !month) {
//     let getIndex = headerQuaterList.findIndex((item) => item.value == quarter);
//     let monthList = "";
//     headerMonthsList[getIndex].map((x, i) => {
//       if (i !== 0) {
//         monthList === ""
//           ? (monthList = x.title)
//           : (monthList += " - " + x.title);
//       }
//     });
//     result = `${quarter} (${monthList}) ${year}`;
//   } else {
//     result = `${month} - ${year}`;
//   }
//   return result;
// };
export var empolyeeDefaultSortList = [
    new Sorts([
        {
            title: "Alphabetical",
            key: "empName",
            order: ESortOrder.UNCHANGED,
            type: "string",
            orderText: {
                asc: "A to Z",
                desc: "A to Z",
            },
        },
        {
            title: "Gross Revenue",
            key: "grossRevenue",
            order: ESortOrder.UNCHANGED,
            orderText: {
                asc: "Lowest to Highest",
                desc: "Highest to Lowest",
            },
        },
        {
            title: "SB Passout",
            key: "sbPassout",
            order: ESortOrder.UNCHANGED,
            orderText: {
                asc: "Lowest to Highest",
                desc: "Highest to Lowest",
            },
        },
        {
            title: "Refund/Reversal",
            key: "refund",
            order: ESortOrder.UNCHANGED,
            orderText: {
                asc: "Lowest to Highest",
                desc: "Highest to Lowest",
            },
        },
        {
            title: "Finance Cost",
            key: "financeCost",
            order: ESortOrder.UNCHANGED,
            orderText: {
                asc: "Lowest to Highest",
                desc: "Highest to Lowest",
            },
        },
        {
            title: "Net Revenue",
            key: "netRevenue",
            order: ESortOrder.UNCHANGED,
            orderText: {
                asc: "Lowest to Highest",
                desc: "Highest to Lowest",
            },
        },
    ]),
];
export var productDefaultSortList = [
    new Sorts([
        {
            title: "Alphabetical",
            key: "product",
            order: ESortOrder.UNCHANGED,
            type: "string",
            orderText: {
                asc: "A to Z",
                desc: "A to Z",
            },
        },
        {
            title: "Gross Revenue",
            key: "grossRevenue",
            order: ESortOrder.UNCHANGED,
            orderText: {
                asc: "Lowest to Highest",
                desc: "Highest to Lowest",
            },
        },
        {
            title: "SB Passout",
            key: "sbPassout",
            order: ESortOrder.UNCHANGED,
            orderText: {
                asc: "Lowest to Highest",
                desc: "Highest to Lowest",
            },
        },
        {
            title: "Refund/Reversal",
            key: "refund",
            order: ESortOrder.UNCHANGED,
            orderText: {
                asc: "Lowest to Highest",
                desc: "Highest to Lowest",
            },
        },
        {
            title: "Finance Cost",
            key: "financeCost",
            order: ESortOrder.UNCHANGED,
            orderText: {
                asc: "Lowest to Highest",
                desc: "Highest to Lowest",
            },
        },
        {
            title: "Net Revenue",
            key: "netRevenue",
            order: ESortOrder.UNCHANGED,
            orderText: {
                asc: "Lowest to Highest",
                desc: "Highest to Lowest",
            },
        },
    ]),
];
export var locationDefaultSortList = [
    new Sorts([
        {
            title: "Alphabetical",
            key: "zoneName",
            order: ESortOrder.UNCHANGED,
            type: "string",
            orderText: {
                asc: "A to Z",
                desc: "A to Z",
            },
        },
        {
            title: "Gross Revenue",
            key: "grossRevenue",
            order: ESortOrder.UNCHANGED,
            orderText: {
                asc: "Lowest to Highest",
                desc: "Highest to Lowest",
            },
        },
        {
            title: "SB Passout",
            key: "sbPassout",
            order: ESortOrder.UNCHANGED,
            orderText: {
                asc: "Lowest to Highest",
                desc: "Highest to Lowest",
            },
        },
        {
            title: "Refund/Reversal",
            key: "reversal",
            order: ESortOrder.UNCHANGED,
            orderText: {
                asc: "Lowest to Highest",
                desc: "Highest to Lowest",
            },
        },
        {
            title: "Finance Cost",
            key: "financeCost",
            order: ESortOrder.UNCHANGED,
            orderText: {
                asc: "Lowest to Highest",
                desc: "Highest to Lowest",
            },
        },
        {
            title: "Net Revenue",
            key: "netRevenue",
            order: ESortOrder.UNCHANGED,
            orderText: {
                asc: "Lowest to Highest",
                desc: "Highest to Lowest",
            },
        },
    ]),
];
export var periodDropdownList = [
    { title: "Yearly", value: "Yearly" },
    { title: "Monthly", value: "Monthly" },
    { title: "Quarterly", value: "quarterly" },
];
export var currentYearMonthsArr = [
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
];
export var nextYearMonthsArr = ["Jan", "Feb", "Mar"];
export var quartersArr = ["Q1", "Q2", "Q3", "Q4"];
export var totalList = {
    grossRevenue: 0,
    sbPassout: 0,
    refund: 0,
    financeCost: 0,
    netReveneue: 0,
    previousNrL: 0,
    previousNrLL: 0,
};
var monthListForTrHeading = ["", "Apr-Jun", "Jul-Sep", "Oct-Dec", "Jan-Mar"];
export var tableHeadingExecution = function (year, periodValue, quarterOrMonth) {
    var _a;
    var result = "";
    if (year && (!quarterOrMonth || quarterOrMonth == "")) {
        result = year;
    }
    else if (year &&
        periodValue == headerQuarterListEnum.MONTHS &&
        !!quarterOrMonth) {
        result = "".concat(quarterOrMonth, " - ").concat(year);
    }
    else if (year &&
        periodValue == headerQuarterListEnum.QUARTER &&
        !!quarterOrMonth) {
        var getIndex = headerQuaterList.findIndex(function (item) { return item.value == quarterOrMonth; });
        var monthList_1 = "";
        (_a = headerMonthsList[getIndex - 1]) === null || _a === void 0 ? void 0 : _a.map(function (x, i) {
            if (i !== 0) {
                monthList_1 === ""
                    ? (monthList_1 = x.title)
                    : (monthList_1 += " - " + x.title);
            }
        });
        result = "".concat(quarterOrMonth, " (").concat(monthList_1, ") ").concat(year);
    }
    return result;
};
export var managePreviousNR = function (year, periodValue, quarterOrMonth) {
    var result = {
        heading1: "",
        heading2: "",
    };
    if (year && (!quarterOrMonth || quarterOrMonth == "")) {
        var splitYear = year.split("-");
        result.heading1 = "FY - ".concat(getPreviousYear(Number(splitYear[1]), 1, "YYYY"));
        result.heading2 = "FY - ".concat(getPreviousYear(Number(splitYear[1]), 2, "YYYY"));
    }
    else if (year &&
        periodValue == headerQuarterListEnum.QUARTER &&
        !!quarterOrMonth) {
        var splitQuarter = quarterOrMonth.split("");
        result.heading1 = "Q".concat(getPreviousQuarter(Number(splitQuarter[1]), 1, "Q"), " (").concat(monthListForTrHeading[Number(getPreviousQuarter(Number(splitQuarter[1]), 1, "Q"))], ")");
        result.heading2 = "Q".concat(getPreviousQuarter(Number(splitQuarter[1]), 2, "Q"), " (").concat(monthListForTrHeading[Number(getPreviousQuarter(Number(splitQuarter[1]), 2, "Q"))], ")");
    }
    else if (year &&
        periodValue == headerQuarterListEnum.MONTHS &&
        !!quarterOrMonth) {
        result.heading1 = getPreviousMonth(quarterOrMonth, 1, "MMMM");
        result.heading2 = getPreviousMonth(quarterOrMonth, 2, "MMMM");
    }
    return result;
};
var getPreviousMonth = function (month, prevNo, formet) {
    return moment().month(month).subtract(prevNo, "month").format(formet);
};
var getPreviousYear = function (year, prevNo, formet) {
    return moment().year(year).subtract(prevNo, "year").format(formet);
};
var getPreviousQuarter = function (quarter, prevNo, formet) {
    return moment().quarter(quarter).subtract(prevNo, "quarter").format(formet);
};
export var getMonthName = function (monthName, yearName) {
    var _a, _b, _c;
    var updatedMonthName;
    if (currentYearMonthsArr.some(function (item) { return monthName === null || monthName === void 0 ? void 0 : monthName.match(new RegExp("".concat(item))); })) {
        var newTitle = yearName === null || yearName === void 0 ? void 0 : yearName.split("-");
        newTitle.pop();
        updatedMonthName =
            monthName + "'" + ((_c = (_b = (_a = newTitle[0]) === null || _a === void 0 ? void 0 : _a.split("")) === null || _b === void 0 ? void 0 : _b.splice(4, 2)) === null || _c === void 0 ? void 0 : _c.join(""));
    }
    else if (nextYearMonthsArr.includes(monthName)) {
        var newTitle = yearName === null || yearName === void 0 ? void 0 : yearName.split("-");
        updatedMonthName = monthName + "'" + newTitle[1];
    }
    return updatedMonthName;
};
export var getYearName = function (year, appendSpace) {
    var _a, _b, _c;
    var newTitle = year === null || year === void 0 ? void 0 : year.split("-");
    newTitle.pop();
    var temp1 = (_a = newTitle[0]) === null || _a === void 0 ? void 0 : _a.split("");
    var update = "".concat((_b = temp1 === null || temp1 === void 0 ? void 0 : temp1.splice(0, 2)) === null || _b === void 0 ? void 0 : _b.join("")).concat(appendSpace ? " " : "").concat((_c = temp1 === null || temp1 === void 0 ? void 0 : temp1.splice(2, 3)) === null || _c === void 0 ? void 0 : _c.join(""));
    return update;
};
export var getQuarterName = function (quarterName, year) {
    var _a, _b;
    var yearName = (_b = (_a = year === null || year === void 0 ? void 0 : year.split("")) === null || _a === void 0 ? void 0 : _a.splice(4, 2)) === null || _b === void 0 ? void 0 : _b.join("");
    var updatedQuarterName = quarterName + "'" + yearName;
    return updatedQuarterName;
};
export var getFullYear = function (value) {
    var _a, _b;
    var yearName = "";
    if (typeof value === "string") {
        yearName = (_b = (_a = value === null || value === void 0 ? void 0 : value.split("")) === null || _a === void 0 ? void 0 : _a.splice(2, 4)) === null || _b === void 0 ? void 0 : _b.join("");
    }
    return yearName;
};
